import React from 'react'

const Cp_st_srt = () => {
    return (
        <div className='container'>
            <h1><div class="title">Sort a stack using a temporary stack</div></h1>
            <p>Given a stack of integers, sort it in descending order using another temporary stack.</p>
            <p><strong>Examples:</strong></p>
            <pre className='output'>Input : [34, 3, 31, 98, 92, 23] <br />
Output : [3, 23, 31, 34, 92, 98] <br />
 <br />
Input : [3, 5, 1, 4, 2, 8] <br />
Output : [1, 2, 3, 4, 5, 8] <br />
</pre>
<p>We follow this algorithm.</p>
<ol>
    <li>Create a temporary stack say <strong>tmpStack</strong>.</li>
<li>While input stack is NOT empty do this:
    <ul>
        <li>Pop an element from input stack call it <strong>temp</strong></li>
<li>while temporary stack is NOT empty and top of temporary stack is greater than temp,<br/>
pop from temporary stack and push it to the input stack</li>
<li>push <strong>temp</strong> in temporary stack</li>
</ul></li>
<li>The sorted numbers are in tmpStack</li>
</ol>
<p>Here is a dry run of above pseudo code.</p>
<pre  className='output'>input: [34, 3, 31, 98, 92, 23] <br />
 <br />
Element taken out: 23 <br />
input: [34, 3, 31, 98, 92] <br />
tmpStack: [23] <br />
 <br />
Element taken out: 92 <br />
input: [34, 3, 31, 98] <br />
tmpStack: [23, 92] <br />
 <br />
Element taken out: 98 <br />
input: [34, 3, 31] <br />
tmpStack: [23, 92, 98] <br />
 <br />
Element taken out: 31 <br />
input: [34, 3, 98, 92] <br />
tmpStack: [23, 31] <br />
 <br />
Element taken out: 92 <br />
input: [34, 3, 98] <br />
tmpStack: [23, 31, 92] <br />
 <br />
Element taken out: 98 <br />
input: [34, 3] <br />
tmpStack: [23, 31, 92, 98] <br />
 <br />
Element taken out: 3 <br />
input: [34, 98, 92, 31, 23] <br />
tmpStack: [3] <br />
 <br />
Element taken out: 23 <br />
input: [34, 98, 92, 31] <br />
tmpStack: [3, 23] <br />
 <br />
Element taken out: 31 <br />
input: [34, 98, 92] <br />
tmpStack: [3, 23, 31] <br />
 <br />
Element taken out: 92 <br />
input: [34, 98] <br />
tmpStack: [3, 23, 31, 92] <br />
 <br />
Element taken out: 98 <br />
input: [34] <br />
tmpStack: [3, 23, 31, 92, 98] <br />
 <br />
Element taken out: 34 <br />
input: [98, 92] <br />
tmpStack: [3, 23, 31, 34] <br />
 <br />
Element taken out: 92 <br />
input: [98] <br />
tmpStack: [3, 23, 31, 34, 92] <br />
 <br />
Element taken out: 98 <br />
input: [] <br />
tmpStack: [3, 23, 31, 34, 92, 98] <br />
 <br />
final sorted list: [3, 23, 31, 34, 92, 98] <br />
</pre>
<div class="containers">
        <div class="line number1 index0 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;</div>
        <div class="line number2 index1 alt1"><code class="comment">// C++ program to sort a stack using an</code>
        </div>
        <div class="line number3 index2 alt2"><code class="comment">// auxiliary stack.</code></div>
        <div class="line number4 index3 alt1"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div>
        <div class="line number5 index4 alt2"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number6 index5 alt1 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number7 index6 alt2 highlighted"><code
                        class="comment">// This function return the sorted stack</code></div>
        <div class="line number8 index7 alt1 highlighted"><code class="plain">stack&lt;</code><code
                        class="keywords">int</code><code class="plain">&gt; sortStack(stack&lt;</code><code
                        class="keywords">int</code><code class="plain">&gt; &amp;input)</code></div>
        <div class="line number9 index8 alt2 highlighted"><code class="plain">&#123;</code></div>
        <div class="line number10 index9 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">stack&lt;</code><code class="keywords">int</code><code
                        class="plain">&gt; tmpStack;</code></div>
        <div class="line number11 index10 alt2 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number12 index11 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="library">while</code>
                <code class="plain">(!input.empty())</code></div>
        <div class="line number13 index12 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
        <div class="line number14 index13 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// pop out the first element</code></div>
        <div class="line number15 index14 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">tmp = input.top();</code></div>
        <div class="line number16 index15 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.pop();</code></div>
        <div class="line number17 index16 alt2 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number18 index17 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// while temporary stack is not empty and top</code></div>
        <div class="line number19 index18 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// of stack is greater than temp</code></div>
        <div class="line number20 index19 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">while</code> <code
                        class="plain">(!tmpStack.empty() &amp;&amp; tmpStack.top() &gt; tmp)</code></div>
        <div class="line number21 index20 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number22 index21 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// pop from temporary stack and push</code></div>
        <div class="line number23 index22 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// it to the input stack</code></div>
        <div class="line number24 index23 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(tmpStack.top());</code></div>
        <div class="line number25 index24 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">tmpStack.pop();</code></div>
        <div class="line number26 index25 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number27 index26 alt2 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number28 index27 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// push temp in tempory of stack</code></div>
        <div class="line number29 index28 alt2 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">tmpStack.push(tmp);</code></div>
        <div class="line number30 index29 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
        <div class="line number31 index30 alt2 highlighted"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number32 index31 alt1 highlighted"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="library">return</code>
                <code class="plain">tmpStack;</code></div>
        <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
        <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number35 index34 alt2"><code class="comment">// main function</code></div>
        <div class="line number36 index35 alt1"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number37 index36 alt2"><code class="plain">&#123;</code></div>
        <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">stack&lt;</code><code class="keywords">int</code><code
                        class="plain">&gt; input;</code></div>
        <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(34);</code></div>
        <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(3);</code></div>
        <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(31);</code></div>
        <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(98);</code></div>
        <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(92);</code></div>
        <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">input.push(23);</code></div>
        <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// This is the temporary stack</code></div>
        <div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">stack&lt;</code><code class="keywords">int</code><code
                        class="plain">&gt; tmpStack = sortStack(input);</code></div>
        <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; </code><code class="string">"Sorted numbers are:\n"</code><code
                        class="plain">;</code></div>
        <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;</code>&nbsp;</div>
        <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">while</code> <code class="plain">(!tmpStack.empty())</code></div>
        <div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#123;</code></div>
        <div class="line number52 index51 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; tmpStack.top()&lt;&lt; </code><code class="string">" "</code><code
                        class="plain">;</code></div>
        <div class="line number53 index52 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">tmpStack.pop();</code></div>
        <div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number55 index54 alt2"><code class="plain">&#125;</code></div>
</div>
<strong>Output:</strong>
<div className='output'>
<pre> Sorted numbers are: <br />
98 92 34 31 23 3</pre>
</div>
        </div>
    )
}

export default Cp_st_srt
